import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";

const AddSalesmanForm = ({ open, onClose, onSubmit }) => {
  const getDropDownData = useSelector((state) => state.app.curretDropdownData);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    zone_id: getDropDownData?.zone_id,
    mobile_no: "",
    address:""
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      zone_id: getDropDownData.zone_id,
    }));
  }, [getDropDownData, open]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateMobileNumber = () => {
    const mobileNumber = formData.mobile_no;
  
    // Check if the mobile number is a string of 10 digits
    if (mobileNumber && mobileNumber.length === 10 && !isNaN(mobileNumber)) {
      return true;
    }
  
    return false;
  };
  
  const handleFormSubmit = () => {
    const newErrors = {};
    
    // Validate first_name and last_name
    if (!formData?.first_name?.trim()) {
      newErrors.first_name = "First Name is required";
    }

    if (!formData?.last_name?.trim()) {
      newErrors.last_name = "Last Name is required";
    }

    if (!formData?.address?.trim()) {
      newErrors.address = "Address is required";
    }

    // Validate mobile_no
    if (!formData?.mobile_no?.trim()) {
      newErrors.mobile_no = "Mobile Number is required";
    } else if (!validateMobileNumber()) {
      newErrors.mobile_no = "Invalid Mobile Number";
    }

    // If there are errors, setErrors and return
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // If no errors, submit the form
  
    onClose();  onSubmit(formData);
    setFormData({});
    setErrors({});
  };
  
  const handleClose = () => {
    onClose();
    setFormData({
      name: '',
      zone_id: getDropDownData.zone_id,
      mobile_no: '',
    });
    setErrors({});
  };
  
  return (
    <Dialog
      maxWidth={"800px"}
      open={open}
      onClose={onClose}
      sx={{ width: "50vw", margin: "auto" }}
    >
      <DialogTitle>Add Sales Partner</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "40vw",
        }}
      >
        <label htmlFor="first_name">First Name:</label>
        <TextField
          size="small"
          type="text"
          id="first_name"
          name="first_name"
          value={formData.first_name}
          onChange={handleInputChange}
          fullWidth
          required
          error={Boolean(errors.first_name)}
          helperText={errors.first_name}
        />

        <label htmlFor="last_name">Last Name:</label>
        <TextField
          size="small"
          type="text"
          id="last_name"
          name="last_name"
          value={formData.last_name}
          onChange={handleInputChange}
          fullWidth
          required
          error={Boolean(errors.last_name)}
          helperText={errors.last_name}
        />

        <label htmlFor="zone_id">Zone Name:</label>
        <TextField
          size="small"
          type="text"
          id="zone_id"
          name="zone_id"
          value={getDropDownData?.zone_name}
          onChange={handleInputChange}
          fullWidth
          disabled
        />

        <label htmlFor="mobile_no">Mobile Number:</label>
        <TextField
          size="small"
          type="text"
          id="mobile_no"
          name="mobile_no"
          value={formData.mobile_no}
          onChange={handleInputChange}
          fullWidth
          required
          error={Boolean(errors.mobile_no)}
          helperText={errors.mobile_no}
        />
        <label htmlFor="address">Address:</label>
        <TextField
          size="small"
          type="text"
          id="address"
          name="address"
          value={formData.address}
          onChange={handleInputChange}
          fullWidth
          required
          error={Boolean(errors.address)}
          helperText={errors.address}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => { onClose(); handleClose(); }} sx={{ color: "gray" }}>
          Cancel
        </Button>
        <Button
          onClick={handleFormSubmit}
          variant="contained"
          sx={{
            backgroundColor: "#DC1D13",
            ":hover": {
              backgroundColor: "#960c08",
            },
          }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSalesmanForm;
